/**
 * Hr api spec
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ReadCompanyDto } from './readCompanyDto';


export interface ReadUserDto { 
    /**
     * The unique identifier of the user
     */
    id: string;
    /**
     * The authentication ID of the user
     */
    authId: string;
    /**
     * The first name of the user
     */
    firstname: string;
    /**
     * The last name of the user
     */
    lastname: string;
    /**
     * The email address of the user
     */
    email: string;
    /**
     * The phone number of the user
     */
    phone: string;
    /**
     * The roles assigned to the user
     */
    role: ReadUserDto.RoleEnum;
    /**
     * The companies associated with the user
     */
    companies: Array<ReadCompanyDto>;
    /**
     * The user who created this user
     */
    createdBy: ReadUserDto;
    /**
     * creation date
     */
    createdAt: string;
    /**
     * update date
     */
    updatedAt: string;
}
export namespace ReadUserDto {
    export const RoleEnum = {
        Hr: 'HR',
        Admin: 'ADMIN',
        Technician: 'TECHNICIAN'
    } as const;
    export type RoleEnum = typeof RoleEnum[keyof typeof RoleEnum];
}


